(function () {
  'use strict';

  function initShowroomTabs(container) {
    if (!container || container.dataset.tabsInitialized) return;
    container.dataset.tabsInitialized = 'true';

    const tabs = container.querySelectorAll('.sensen-showroom-tab-btn');
    const panels = container.querySelectorAll('.sensen-showroom-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-target');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });

        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        const activePanel = container.querySelector('#' + targetId);
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  }

  function initAllShowrooms() {
    const containers = document.querySelectorAll('.sensen-showrooms-section');
    containers.forEach(initShowroomTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllShowrooms);
  } else {
    initAllShowrooms();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId) {
      const container = document.getElementById('SensenShowrooms-' + e.detail.sectionId);
      if (container) {
        delete container.dataset.tabsInitialized;
        initShowroomTabs(container);
      }
    }
  });
})();
